import { apiRetailFamilies } from '@spo/services/api';
import { getCurrentLanguage } from '@spo/services/i18n';
import { useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';

export const useSearchRetailFamily = (
  search: string,
  offerDate: string,
  debounce = false,
) => {
  return useQuery({
    queryKey: ['useSearchRetailFamily', search],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (!signal?.aborted) {
        const response = await apiRetailFamilies.getRetailFamilies({
          search,
          familyIds: [],
          date: offerDate,
          language: getCurrentLanguage(),
          limit: '30',
        });
        return response;
      }
    },
  });
};

export const useRetailFamilyById = (
  familyId: number,
  offerDate: string,
  debounce = false,
) => {
  return useQuery({
    queryKey: ['useRetailFamilyById', familyId],
    queryFn: async ({ signal }) => {
      if (debounce) {
        await sleep(500);
      }
      if (!signal?.aborted && familyId) {
        const response = await apiRetailFamilies.getRetailFamilies({
          search: '',
          familyIds: [familyId.toString()],
          date: offerDate,
          language: getCurrentLanguage(),
          limit: '30',
        });
        return response;
      }
    },
  });
};
